import React from 'react';
import PropTypes from 'prop-types';
import { customDateFormat } from 'helpers/dateFormat';

import defaultIcon from 'assets/AllCropSVGs/fallow.svg';
import CropIcons from 'helpers/getCropIconByCropName';
import CropIconMapping from 'components/CropIconMapping';
import FieldIcon from '../../../../../../../components/Icons/FieldIcon';
import toCamelCase from '../../helpers/toCamelCase';

const PropertyCropHistoryFullCell = ({ data, field }) => {
  const roundDecimal = data?.appliedArea?.toFixed(2);
  const empty = '---';
  const scrubbedProduct = {
    ...data,
    name: data?.cropname?.replaceAll(' ', '')
  };
  const cropName = scrubbedProduct?.name?.includes(':')
    ? scrubbedProduct?.name
        .split(':')
        .map(part => toCamelCase(part.trim()))
        .join('')
    : scrubbedProduct?.name;

  // One column of the row, picked by `field`: the UI Kit table renders
  // cell by cell.
  const cells = {
    cropseason: data?.cropseason ?? empty,
    cropname: (
      <div className="flex gap-1">
        {cropName in CropIcons ? (
          <CropIconMapping cropObject={scrubbedProduct} />
        ) : (
          <img src={defaultIcon} alt="crop" />
        )}
        {data?.cropname}
      </div>
    ),
    variety: <div>{data?.variety ?? empty}</div>,
    plantingDate: (
      <div>
        {data.plantingDate ? (
          <div>{customDateFormat(data?.plantingDate, 'MMM dd, yyyy')}</div>
        ) : (
          empty
        )}
      </div>
    ),
    appliedArea: data?.appliedArea ? (
      <div>
        <div className="flex gap-1 items-start">
          <FieldIcon
            id="field-card-icon"
            width={18}
            height={18}
            features={[{ geometry: data.geometry, type: 'Feature' }]}
          />
          <div>{data?.cropname}</div>
        </div>
        <div className="text-xs text-neutral-60 text-left">
          {`${roundDecimal} ac`}
        </div>
      </div>
    ) : (
      empty
    )
  };

  return cells[field] ?? null;
};

PropertyCropHistoryFullCell.propTypes = {
  field: PropTypes.string.isRequired,
  data: PropTypes.shape({
    cropname: PropTypes.string.isRequired,
    cropseason: PropTypes.string.isRequired,
    variety: PropTypes.string,
    plantingDate: PropTypes.string,
    appliedArea: PropTypes.number,
    geometry: PropTypes.objectOf(PropTypes.shape())
  }).isRequired
};

export default PropertyCropHistoryFullCell;
